import React from 'react';

import noop from 'lodash/noop';

import {formField, newFormField} from '../FormField';
import {HiddenInput} from '../primitives';
import {TSize} from '../types';
import * as S from './style';

type TValue = any;

export type TProps = {
  id?: string;
  className?: string;
  name?: string;
  size?: TSize;
  value: TValue;
  checked?: boolean;
  readOnly?: boolean;
  disabled?: boolean;
  onChange?: (payload: TValue) => void;
  onFocus?: (payload: TValue) => void;
  onBlur?: (payload: TValue) => void;
  children?: React.ReactNode;
};

const ToggleButton = React.memo<TProps>(
  ({
    value,
    className,
    checked,
    disabled,
    readOnly,
    children,
    name,
    id: propId,
    size = 'M',
    onChange = noop,
    onFocus = noop,
    onBlur = noop,
  }) => {
    const id = `${propId ?? name}/${value}`;

    return (
      <S.ToggleButton
        className={className}
        readOnly={readOnly}
        disabled={disabled}
        checked={checked}
        size={size}
      >
        <HiddenInput
          id={id}
          type="radio"
          disabled={disabled}
          name={name}
          value={String(value)}
          // onClick потому что событие onChange срабатывает не всегда
          onClick={disabled || readOnly ? undefined : onChange}
          onFocus={disabled ? undefined : onFocus}
          onBlur={disabled ? undefined : onBlur}
        />
        {children}
      </S.ToggleButton>
    );
  },
);

export default ToggleButton;

export const ToggleButtonField = formField<TProps, TValue>(ToggleButton);

export const NewToggleButtonField = newFormField<TProps>(ToggleButton);
